import { MAX_LIMIT } from 'config';
import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import { SalesTypeValues } from 'maps/sales-types';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';
import { TSwitcherPeriod } from 'components/base/DateRange/PeriodSwitcher';

export interface ITrendUrlArgs {
  breakdown?: string;
  customerFilter?: TopicFilterNames[];
  countryIds?: string[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  period?: string;
  compareMode?: string;
  salesType: SalesTypeValues;
  userData?: boolean;
  mediaTypes?: string;
  accessBreakdown?: boolean;
  region?: string;
  timeBoxingMode?: boolean;
  limit?: number;
  customDate?: {
    fromDate: number;
    toDate: number;
    dateRangePeriod: TSwitcherPeriod;
  } | null;
  customRegion?: string[] | string;
}

function getTrendUrl(args: ITrendUrlArgs): string {
  const {
    breakdown,
    customerFilter,
    countryIds,
    download,
    entityType,
    entityIds,
    period,
    salesType,
    mediaTypes,
    accessBreakdown,
    region,
    timeBoxingMode,
    limit,
    customDate,
    compareMode,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = stringify({
    breakdown,
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    period: customDate ? customDate.dateRangePeriod || 'week' : period,
    limit: limit ? limit : period === 'year' ? MAX_LIMIT : undefined,
    mediaTypes,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
    timeBoxingMode,
    dateFrom: customDate?.fromDate,
    dateTo: customDate?.toDate,
  });

  const url = `/api/${salesType}${
    accessBreakdown ? '/access' : ''
  }/trend/${type}/${entityIds}?${params}`;

  return url;
}

export default getTrendUrl;
